__turbopack_context__.v({
  "button": "exclusive-offer-module-scss-module__Z5sJVW__button",
  "copyContainer": "exclusive-offer-module-scss-module__Z5sJVW__copyContainer",
  "disclaimer": "exclusive-offer-module-scss-module__Z5sJVW__disclaimer",
  "exclusiveOffer": "exclusive-offer-module-scss-module__Z5sJVW__exclusiveOffer",
  "footer": "exclusive-offer-module-scss-module__Z5sJVW__footer",
  "icon": "exclusive-offer-module-scss-module__Z5sJVW__icon",
  "iconContainer": "exclusive-offer-module-scss-module__Z5sJVW__iconContainer",
  "iconCopyContainer": "exclusive-offer-module-scss-module__Z5sJVW__iconCopyContainer",
  "iconCopyRow": "exclusive-offer-module-scss-module__Z5sJVW__iconCopyRow",
  "image": "exclusive-offer-module-scss-module__Z5sJVW__image",
  "imageContainer": "exclusive-offer-module-scss-module__Z5sJVW__imageContainer",
  "title": "exclusive-offer-module-scss-module__Z5sJVW__title",
});
